import React from 'react'
import context from '@/context'
import Resx from '@/components/Resx'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow, PropertyRenderer } from '@/components/changeRequests'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { decimalMaxChangeItemValue } from '@/utils/constants'

function CapitalOperationDialog (props) {
  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Institutions.CapitalOperation' {...props} />
        <ModalBody>
          <Resx render={(localize) => <CapitalOperationForm localize={localize} target={props.target} />} />
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

function CapitalOperationForm ({ localize, target }) {
  return (
    <React.Fragment>
      <div className='row'>
        <div className='col-6'>
          <FormRow label='Common.Type' name='bankCapitalOperationType' target={target} inputType='lookup' dataSource={req => context.cache.getBankCapitalOperationTypes(req)}
            localize={localize} clientSide isCodeList required />
        </div>
        <div className='col-6'>
          <FormRow label='Institutions.OperationDate' name='operationDate' target={target} inputType='date' required />
        </div>
      </div>
      <div className='row'>
        <div className='col-6'>
          <FormRow label='Institutions.CapitalizationAmount' name='capitalizationAmount'
            target={target} inputType='number' localize={localize} maxValue={decimalMaxChangeItemValue} />
        </div>
        <div className='col-6'>
          <FormRow label='Institutions.UnderwritingAmount' name='underwritingAmount'
            target={target} inputType='number' localize={localize} maxValue={decimalMaxChangeItemValue} />
        </div>
      </div>
      <div className='row'>
        <div className='col-6'>
          <FormRow label='Institutions.ParticipationAmount' name='participationAmount' target={target}
            inputType='number' localize={localize} maxValue={decimalMaxChangeItemValue} />
        </div>
        <div className='col-6'>
          <FormRow label='Institutions.IncreaseAmount' name='increaseAmount' target={target} inputType='number'
            localize={localize} maxValue={decimalMaxChangeItemValue} />
        </div>
      </div>

      <InfoRow form>
        <InfoLabel><Resx name='Common.Description' /></InfoLabel>
        <InfoContent>
          <PropertyRenderer name={'description'} target={target} inputType='textarea' inputProps={{ rows: 10 }} />
        </InfoContent>
      </InfoRow>
    </React.Fragment>
  )
}

export default {
  modalProps: {
    size: 'lg'
  },
  component: CapitalOperationDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/capitalOperation.js